import { useState, useEffect } from "react";
// Returns true if running in a mobile browser (Android/iOS). Defaults to false on SSR.
export function useIsMobileWeb() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        if (typeof navigator === "undefined")
            return;
        const ua = navigator.userAgent || "";
        const mobileRegex = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini|Mobile/i;
        setIsMobile(mobileRegex.test(ua));
    }, []);
    return isMobile;
}
